var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmptyKeyword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 65,
    viewBox: "0 0 91 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.1265C8 12.4991 13.3726 7.12646 20 7.12646H69C75.6274 7.12646 81 12.499 81 19.1265V46.8733C81 53.5007 75.6274 58.8733 69 58.8733H20C13.3726 58.8733 8 53.5007 8 46.8733V19.1265Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3779 24.2214C17.3779 20.9042 20.0671 18.2151 23.3843 18.2151H51.1058C54.423 18.2151 57.1121 20.9042 57.1121 24.2214C57.1121 27.5386 54.423 30.2277 51.1058 30.2277H23.3843C20.0671 30.2277 17.3779 27.5386 17.3779 24.2214Z",
    fill: "#E9E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.873 41.7784C33.873 38.4612 36.5622 35.772 39.8794 35.772H65.7528C69.07 35.772 71.7591 38.4612 71.7591 41.7784C71.7591 45.0956 69.07 47.7847 65.7528 47.7847H39.8794C36.5622 47.7847 33.873 45.0956 33.873 41.7784Z",
    fill: "#E9E9E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2466,
    cy: 41.7784,
    r: 6.00633,
    fill: "#E9E9E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyKeyword);
export default __webpack_public_path__ + "static/media/ic_empty_keyword.c320a60db8989f3c5560b378feffdc40.svg";
export { ForwardRef as ReactComponent };